import { z } from 'zod';

export const improvementStatusSchema = z.enum(['open', 'deferred', 'done']);
const fields = {
  title: z.string().trim().min(1, 'Enter a title').max(160, 'Use 160 characters or fewer'),
  description: z.string().max(20000, 'Use 20,000 characters or fewer'),
  status: improvementStatusSchema,
};
export const improvementSchema = z.object({
  ...fields, description: fields.description.default(''), status: fields.status.default('open'),
}).strict();
export const improvementPatchSchema = z.object(fields).partial().strict()
  .refine(value => Object.keys(value).length > 0, 'Provide at least one change');
export type ImprovementInput = z.infer<typeof improvementSchema>;
export type ImprovementPatch = z.infer<typeof improvementPatchSchema>;
export type ImprovementStatus = z.infer<typeof improvementStatusSchema>;
export interface Improvement extends ImprovementInput {
  id: string;
  createdAt: string;
  updatedAt: string;
  createdById: string | null;
  updatedById: string | null;
}
export const improvementStatusLabels: Record<ImprovementStatus, string> = {
  open: 'Open', deferred: 'Deferred', done: 'Done',
};
